(function(){
  function initBar(root){
    if(!root || root.dataset.wcabInit === '1') return;
    root.dataset.wcabInit = '1';

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Dismiss with localStorage ---- */
    if(root.getAttribute('data-dismissible') === 'true'){
      var key = root.getAttribute('data-storage-key');
      try{
        if(key && window.localStorage && window.localStorage.getItem(key) === '1'){
          root.hidden = true;
          return;
        }
      }catch(e){}
      var closeBtn = root.querySelector('[data-wcab-close]');
      if(closeBtn){
        closeBtn.addEventListener('click', function(){
          root.hidden = true;
          try{ if(key && window.localStorage){ window.localStorage.setItem(key, '1'); } }catch(e){}
        });
      }
    }

    /* ---- Countdown ---- */
    var clock = root.querySelector('[data-wcab-clock]');
    var targetStr = root.getAttribute('data-countdown-target');
    var targetMs = targetStr ? Date.parse(targetStr) : NaN;
    if(clock && !isNaN(targetMs)){
      var dEl = root.querySelector('[data-wcab-d]');
      var hEl = root.querySelector('[data-wcab-h]');
      var mEl = root.querySelector('[data-wcab-m]');
      var sEl = root.querySelector('[data-wcab-s]');
      var kickoff = root.querySelector('[data-wcab-kickoff]');
      var label = root.querySelector('[data-wcab-count-label]');
      var pad = function(n){ return (n < 10 ? '0' : '') + n; };
      var timer = null;
      var boxed = root.getAttribute('data-countdown-style') === 'boxed';
      var dGroup = boxed ? root.querySelectorAll('[data-wcab-dgroup]') : [];
      var countEl = root.querySelector('[data-wcab-count]');

      var tick = function(){
        var diff = targetMs - Date.now();
        if(diff <= 0){
          if(boxed && countEl){ countEl.hidden = true; if(timer) clearInterval(timer); return; }
          clock.hidden = true;
          if(label) label.hidden = true;
          if(kickoff) kickoff.hidden = false;
          if(timer) clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600);  s -= h * 3600;
        var m = Math.floor(s / 60);    s -= m * 60;
        if(dEl) dEl.textContent = pad(d);
        for(var i = 0; i < dGroup.length; i++){ dGroup[i].hidden = d === 0; }
        if(hEl) hEl.textContent = pad(h);
        if(mEl) mEl.textContent = pad(m);
        if(sEl) sEl.textContent = pad(s);
        if(boxed && countEl) countEl.setAttribute('data-wcab-ready', '');
      };
      tick();
      timer = setInterval(tick, 1000);
    }

    /* ---- Rotating messages ---- */
    var msgs = root.querySelectorAll('[data-wcab-msg]');
    if(msgs.length > 1){
      var interval = parseFloat(root.getAttribute('data-rotate-interval')) || 5;
      if(interval < 2) interval = 2;
      var idx = 0;
      setInterval(function(){
        if(document.hidden) return;
        msgs[idx].classList.remove('is-active');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('is-active');
      }, interval * 1000);
    }
  }

  function boot(){
    document.querySelectorAll('[data-torras-wcab]').forEach(initBar);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
  document.addEventListener('shopify:section:load', function(e){
    if(e && e.target){ e.target.querySelectorAll('[data-torras-wcab]').forEach(initBar); }
  });
})();
